import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { waLink } from "@/lib/site";

export const WhatsAppBubble = () => {
  const { pathname } = useLocation();
  const msg = pathname.startsWith("/fragrance/")
    ? "Hello Bonheur Eternal, I'm looking at a fragrance on your site and would like to order."
    : "Hello Bonheur Eternal, I'd like to place an order.";
  return (
    <motion.a
      href={waLink(msg)}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-btn"
      aria-label="Order via WhatsApp"
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1.2, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.95 }}
      className="fixed bottom-5 right-5 md:bottom-8 md:right-8 z-40 flex items-center justify-center w-14 h-14 rounded-full bg-[#8F6B3A] text-[#FBF8F1] shadow-[0_8px_30px_rgba(198,168,124,0.35)]"
    >
      <MessageCircle size={24} strokeWidth={1.5} />
    </motion.a>
  );
};
